import React, { Component } from 'react';

//GSAP ALREADY LOADED FROM ANIMATE LIB FILES
// import { TimelineMax } from 'gsap'
const TimelineMax = window.TimelineMax

class PageContainer extends Component {
  constructor(props){
    super(props);
  }

  componentWillEnter(callback) {
    // console.log('pagecontainer will enter', this.props.tester);
    this.props.pageTransitionStart();
    this.animateIn(callback);
  }

  componentDidEnter(){
    // console.log('pagecontainer did enter', this.props.tester);
    this.props.pageTransitionFinish();
  }


  componentWillLeave(callback) {
  	// console.log('pagecontainer will leave');
  	this.animateOut(callback);
    // callback();
  }

  componentDidLeave(){
    // console.log('pagecontainer did leave');
    // this.props.pageExitFinish()
  }

  handlePageExit = () => {
    let { nextPageIndex, currentPageIndex, pageExitFinish } = this.props;
    if(nextPageIndex !== null && !(currentPageIndex === 0 && nextPageIndex === 1)){
      // console.log("PAGE FINISH", currentPageIndex, nextPageIndex)
      pageExitFinish()
    } 
  }

  renderChild() {
    let { nextPage, isMobile, events, child } = this.props
  	let component = React.cloneElement(child, 
  		//DEFAULT PROPERTIES FOR ALL PAGES
      {
        nextPage: nextPage,
        isMobile: isMobile,
        events: events,
        hideReact: this.props.hideReact
      }
    )
    return component
  }

  render() {
  	let child = this.renderChild()
    return (
      <div id="Page" ref={(el) => this.el = el}>
      	{child}
      </div>
    );
  }

  //*************************//
  //*****PAGE ANIMATIONS*****//
  //*************************//
  animateIn(callback){
  	var tween = new TimelineMax({onComplete: callback})
    let el = this.el
    let staggers = el.querySelectorAll('.stagger-in');
    let {duration, staggerDuration, staggerDelay } = this.props.child.props.animation

    tween
    .set(staggers, {opacity: 0, x: '-=16'})
    .set(el, {opacity: 0})
    .to(el, duration, {
      opacity: 1,
      // ease: Sine.easeIn
    })
    .staggerTo(staggers, 0.6, {opacity: 1, x: '+=16'}, staggerDuration, '-=' + staggerDelay)
  }

  animateOut(callback){
    var tween = new TimelineMax({onComplete: callback})
    let staggers = this.el.querySelectorAll('.stagger-in');
    let {duration, staggerDuration, staggerDelay } = this.props.child.props.animation

    let cb = (this.props.nextPageIndex === 1 && this.props.currentPageIndex === 0) ? null : this.handlePageExit
    tween
    // .staggerTo(Array.from(staggers).reverse(), 0.6, {opacity: 0}, staggerDuration, '-=' + staggerDelay)
    .addCallback(cb)
    .to(this.el, .5, {
      opacity: 0,
      // left: '-40vw',
      ease: 'Sine.easeIn'
    })
  }
}

export default PageContainer;


// WEBPACK FOOTER //
// ./src/scripts/containers/PageContainer.js